export default __webpack_public_path__ + "static/media/smartmockups-kkfuwryw-personalizado-768x480.061b0e3b.png";